// No scope selector: exact engine codes are detected from the existing index.
const canonical = (value) => String(value || '').normalize('NFKC').toUpperCase().replace(/[^\p{L}\p{N}]/gu, '');
let engineCodes;
async function loadEngineCodes(form) {
  if (!engineCodes) engineCodes = (async () => {
    const envelope = JSON.parse(form.querySelector('[data-engine-index]').textContent);
    if (envelope?.version !== 2 || envelope.encoding !== 'gzip-base64-delta-ids') throw new Error('Invalid engine index');
    const binary = Uint8Array.from(atob(envelope.data), (c) => c.charCodeAt(0));
    const stream = new Blob([binary]).stream().pipeThrough(new DecompressionStream('gzip'));
    const index = JSON.parse(await new Response(stream).text());
    if (!index.codes || typeof index.codes !== 'object') throw new Error('Missing engine codes');
    return index.codes;
  })();
  return engineCodes;
}
document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!form.matches('[data-automatic-search]')) return;
  if (form.dataset.searchReady === 'true') {
    delete form.dataset.searchReady;
    return;
  }
  event.preventDefault();
  if (form.dataset.searchPending === 'true') return;
  const input = form.querySelector('input[name="q"]');
  const view = form.querySelector('input[name="view"]');
  const raw = input.value.trim();
  if (!raw) { input.focus(); return; }
  const status = document.getElementById(form.dataset.searchStatus);
  if (status) status.hidden = true;
  form.dataset.searchPending = 'true';
  form.setAttribute('aria-busy', 'true');
  try {
    const codes = await loadEngineCodes(form);
    const isEngine = Object.prototype.hasOwnProperty.call(codes, canonical(raw));
    view.disabled = !isEngine;
    if (isEngine) input.value = raw;
    else {
      const keep = raw.toUpperCase().replace(/\s+/g, '');
      const noSep = keep.replace(/[-._/\\]/g, '');
      input.value = keep === noSep ? keep : keep + ' OR ' + noSep;
    }
    form.dataset.searchReady = 'true';
    form.requestSubmit(event.submitter || undefined);
  } catch (_) {
    if (status) status.hidden = false;
    engineCodes = undefined;
  } finally {
    delete form.dataset.searchPending;
    form.removeAttribute('aria-busy');
  }
}, true);
